import { QuestionEntity, QuestionForUpdate, RawQuestion } from './Types';
import { AnswerEntity } from '../Answer/Types';
import { AnswerModel } from '../Answer/AnswerModel';
import { BaseModel } from '../BaseModel/BaseModel';
import {
    QuestionType,
    QuestionTypeEnum,
} from '../../Shared/Enums/QuestionTypeEnum';

export class QuestionModel
    extends BaseModel<RawQuestion, QuestionEntity>
    implements QuestionEntity
{
    key: string = '';
    question: string = '';
    select: QuestionType = QuestionTypeEnum.INPUT;
    value: string = '';
    requiredQuestion?: boolean;
    answers: AnswerEntity[] = [];

    constructor(question?: RawQuestion) {
        super();
        if (question) {
            this.initialize(question);
        }
    }

    initialize(question: RawQuestion) {
        this.key = question.key;
        this.question = question.question;
        this.select = question.select;
        this.requiredQuestion =
            typeof question.required_question === 'boolean'
                ? question.required_question
                : undefined;
        const value =
            typeof question.value === 'object'
                ? (question.value.value as string | number)
                : question.value;

        this.value =
            typeof value === 'string'
                ? parseFloat(value).toFixed(2)
                : value.toFixed(2);

        if (question.answers && question.answers.length > 0) {
            this.answers = question.answers.map(
                answer => new AnswerModel(answer)
            );
        }

        if (!question.answers) {
            const newAnswerData = {
                title: this.value ? this.value.toString() : 'N/A',
                value: typeof this.value === 'object' ? 0 : this.value,
                selected: true,
            };

            this.answers = [new AnswerModel(newAnswerData)];
        }
    }

    parse(): RawQuestion {
        return {
            key: this.key,
            question: this.question,
            select: this.select,
            value: this.value,
            ...(this.answers && {
                answers: this.answers.map(answer => answer.parse()),
            }),
        };
    }

    updateInputValue(newValue: string) {
        this.answers.forEach(answer => answer.updateInputValue(newValue));
        this.value = newValue;
    }

    updateSelectValue(answerUuid: string) {
        const currentAnswer = this.answers.find(
            answer => answer.uuid === answerUuid
        );

        if (!currentAnswer) {
            return;
        }

        currentAnswer.updateSelectValue(true);
        this.answers
            .filter(answer => answer.uuid !== answerUuid)
            .forEach(answer => answer.updateSelectValue(false));

        this.value =
            typeof currentAnswer.value === 'string'
                ? currentAnswer.value
                : currentAnswer.value.toString();
    }

    transformQuestionForUpdate(): QuestionForUpdate {
        return {
            [this.key]: this.question,
            answers: this.answers.map(answer => answer.parse()),
        };
    }
}
